// Base snippet resmi keempat vendor pixel — string builder MURNI (tanpa DOM),
// dipakai DUA komponen injeksi yang tidak boleh menyimpang:
//   • `PixelScripts.tsx`         — pixel per-TOKO di storefront penyewa;
//   • `PlatformPixelScripts.tsx` — pixel PLATFORM di situs jualan kelolify.com.
// Sebelumnya fungsi-fungsi ini privat di PixelScripts; dipindah ke sini saat
// pixel platform lahir supaya snippet vendor punya SATU salinan (perubahan
// versi endpoint vendor = satu edit, dua pemakai).
//
// ⚠️ KONTRAK KEAMANAN: `id` WAJIB sudah lolos `sanitizeStorePixelIds`
// (regex whitelist per-vendor di pixel.ts) SEBELUM sampai ke sini — string
// hasil fungsi ini dieksekusi browser. JSON.stringify di dalamnya lapis kedua
// anti-XSS, bukan satu-satunya pagar. Diuji di `__tests__/pixelSnippets.test.ts`.

/** Base snippet resmi Meta Pixel. */
export function metaBaseCode(id: string): string {
  return (
    "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?" +
    "n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;" +
    "n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;" +
    "t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window," +
    "document,'script','https://connect.facebook.net/en_US/fbevents.js');" +
    `fbq('init',${JSON.stringify(id)});fbq('track','PageView');`
  );
}

/** Base snippet resmi TikTok Pixel. */
export function tiktokBaseCode(id: string): string {
  return (
    "!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];" +
    'ttq.methods=["page","track","identify","instances","debug","on","off",' +
    '"once","ready","alias","group","enableCookie","disableCookie","holdConsent",' +
    '"revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function()' +
    "{t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};" +
    "for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);" +
    "ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)" +
    "ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){" +
    'var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;' +
    "ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{}," +
    "ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};" +
    'n=document.createElement("script");n.type="text/javascript",n.async=!0,' +
    'n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];' +
    "e.parentNode.insertBefore(n,e)};" +
    `ttq.load(${JSON.stringify(id)});ttq.page();}(window,document,'ttq');`
  );
}

/** gtag GA4: config sesudah loader eksternal (`ga4LoaderSrc`). `window.gtag`
 *  ditetapkan eksplisit supaya penembak event tak bergantung hoisting. */
export function ga4BaseCode(id: string): string {
  return (
    "window.dataLayer=window.dataLayer||[];" +
    "window.gtag=window.gtag||function(){window.dataLayer.push(arguments);};" +
    `window.gtag('js',new Date());window.gtag('config',${JSON.stringify(id)});`
  );
}

/** URL loader eksternal gtag — pasangan `ga4BaseCode`. */
export function ga4LoaderSrc(id: string): string {
  return `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
}

/** Base snippet resmi GTM (tanpa <noscript> — pengunjung tanpa JS tak punya
 *  funnel yang bisa dilacak di aplikasi ber-checkout JS ini). */
export function gtmBaseCode(id: string): string {
  return (
    "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime()," +
    "event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s)," +
    "dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
    "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
    `})(window,document,'script','dataLayer',${JSON.stringify(id)});`
  );
}
